<template>
    <div>
        <i18n path="availability.message" tag="div" class="title">
            <template v-slot:store-name>
                {{storeName}}
            </template>
        </i18n>
        <img class="status-icon" src="../../assets/checkmark.svg"/>
        <div class="action">{{ $t('availability.callToAction') }}</div>

        <i18n path="availability.instructions" tag="div" class="instructions">
            <template v-slot:distance>
                {{ distance }}
            </template>
        </i18n>
        <capacity/>
    </div>
</template>

<script>
  import Capacity from './Capacity';

  export default {
    name: 'OccupancyAvailable',
    components: {Capacity},
    computed: {
      distance() {
        return this.$store.getters['i18n/current'].distance;
      },

      storeName() {
        return this.$store.getters['storeName'];
      }
    },
  };
</script>
